module.exports = __webpack_public_path__ + "static/imgs/circle-center-fill.fce16bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/circle/circle-center-fill.png
// module id = ZkDA
// module chunks = 1